/* Natural Nutrients collection grid: category chips and quick add (6 Oct 2026) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var grid = document.querySelector('.nn-grid');
    if (!grid) return;

    /* Chips: show only cards in the chosen category */
    var chips = document.querySelector('[data-nn-chips]');
    if (chips) {
      chips.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-nn-filter]');
        if (!chip) return;
        var f = chip.getAttribute('data-nn-filter');
        chips.querySelectorAll('[data-nn-filter]').forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        grid.querySelectorAll('.nn-card').forEach(function (card) {
          card.hidden = !(f === 'all' || card.getAttribute('data-nn-cat') === f);
        });
      });
    }

    /* Quick add for single-variant products, then open the cart drawer */
    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nn-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var id = parseInt(btn.getAttribute('data-nn-quick-add'), 10);
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 }),
      })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        btn.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        var cartLink = document.querySelector('.site-header a[href="/cart"], a.js-drawer-open-cart, a[href="/cart"]');
        if (cartLink) cartLink.click();
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
    });
  });
})();
